/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-04T19:46:29.226
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getHouseRepeatPlanEditInit,
	getHouseRepeatPlanView
} from '@api/storagemanage/HouseRepeatPlan';

import {
listHouseRepeatPlanConditionInit,
listHouseRepeatPlanConditionByAuthorizations,
deleteHouseRepeatPlanCondition
} from '@api/storagemanage/HouseRepeatPlanCondition';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getHouseRepeatPlanEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseRepeatPlanEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHouseRepeatPlanView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseRepeatPlanView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
